import { Nullable } from 'modules/types/common';
import { createReducer, combineReducers } from '@reduxjs/toolkit';
import { createFetchReducer, DefaultState, FetchingReducerState } from 'store/setLocalStore';
import { FormattedEvent } from 'serverTypes/event';
import * as actions from './actions';

export interface SelectedEvent extends DefaultState {
  data: Event;
}
export interface EventsState {
  acknowledgeEvent: DefaultState;
  dismissEvent: DefaultState;
  eventList: EventListState;
  patchEvent: PatchEventState;
  selectedEvent: SelectedEvent;
}

export type EventListState = FetchingReducerState<FormattedEvent[]>;

export interface PatchEventState {
  isFetching: boolean;
  error: Nullable<Error>;
  isComplete: boolean;
  message: Nullable<string>;
}

export const patchEventInitialState = (): PatchEventState => ({
  isFetching: false,
  error: null,
  isComplete: false,
  message: null
});

export const patchEventReducer = createReducer(patchEventInitialState(), {
  [actions.PATCH_EVENT]: state => {
    state.isFetching = true;
    state.isComplete = false;
    state.error = null;
    state.message = null;
  },
  [actions.PATCH_EVENT_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
    state.message = action.error;
  },
  [actions.PATCH_EVENT_SUCCESS]: state => {
    state.isFetching = false;
    state.isComplete = true;
  },
  [actions.PATCH_EVENT_RESET]: state => {
    state.isComplete = false;
  },
  [actions.SET_PATCH_EVENT_MESSAGE]: (state, action) => {
    state.message = action.message;
  }
});

export default combineReducers({
  acknowledgeEvent: createFetchReducer(actions.POST_ACKNOWLEDGE_EVENT),
  dismissEvent: createFetchReducer(actions.DISMISS_EVENT),
  eventList: createFetchReducer<FormattedEvent[]>(actions.GET_UPDATE_EVENT_LIST, true),
  patchEvent: patchEventReducer,
  selectedEvent: createFetchReducer(actions.GET_EVENT)
});
